import React from "react";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/app/PageHeader";
import { AccFileFormDialog } from "./AccFileFormDialog";
import { BookOpen } from "@phosphor-icons/react";
import { fetcher } from "./common";

function FilesTable({ files, isLoading, onOpen }) {
  return (
    <div className="border border-zinc-200 bg-white rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-200">
          <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-zinc-500">
            <th className="px-4 py-3">Dossier</th>
            <th className="px-4 py-3">Client</th>
            <th className="px-4 py-3">Plan comptable</th>
            <th className="px-4 py-3">Devise</th>
            <th className="px-4 py-3">TVA</th>
            <th className="px-4 py-3">Créé le</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-100">
          {isLoading && <tr><td colSpan={6} className="p-6 text-zinc-500">Chargement…</td></tr>}
          {!isLoading && files.length === 0 && <tr><td colSpan={6} className="p-6 text-zinc-500">Aucun dossier comptable. Créez le premier.</td></tr>}
          {files.map((f) => (
            <tr key={f.id} data-testid={`accfile-row-${f.id}`} className="hover:bg-zinc-50 cursor-pointer" onClick={() => onOpen(f.id)}>
              <td className="px-4 py-3 font-medium flex items-center gap-2"><BookOpen size={16} className="text-zinc-500" />{f.name}</td>
              <td className="px-4 py-3">{f.client_name}</td>
              <td className="px-4 py-3">{f.chart_label}</td>
              <td className="px-4 py-3">{f.currency}</td>
              <td className="px-4 py-3">{f.tva_rate}%</td>
              <td className="px-4 py-3 text-zinc-500">{new Date(f.created_at).toLocaleDateString("fr-FR")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Accounting() {
  const navigate = useNavigate();
  const { data: files = [], isLoading } = useSWR("/accounting/files", fetcher);
  const { data: clients = [] } = useSWR("/clients", fetcher);

  return (
    <div>
      <PageHeader
        eyebrow="Production comptable"
        title="Comptabilité OHADA"
        description="Dossiers comptables par client — plan SYSCOHADA révisé ou PCEC/COBAC selon le secteur."
        actions={<AccFileFormDialog clients={clients} onCreated={(id) => navigate(`/comptabilite/${id}`)} />}
      />
      <FilesTable files={files} isLoading={isLoading} onOpen={(id) => navigate(`/comptabilite/${id}`)} />
    </div>
  );
}
